// Topical, high-quality medical/pathology cover images (1200x630-optimised Unsplash URLs).
// Used automatically when an article has no explicit cover_image — NEVER the doctor's portrait.

// Default fallback banner: neutral clean lab/microscope shot with brand tone.
export const DEFAULT_ARTICLE_COVER =
  "https://images.unsplash.com/photo-1579154204601-01588f351e67?auto=format&fit=crop&w=1200&h=630&q=80";

// Ordered topic → image mapping. First matching tag/keyword wins.
const TOPIC_COVERS = [
  { match: ["dengue", "platelet", "cbc", "haematology", "hematology", "blood smear", "haemogram"],
    url: "https://images.unsplash.com/photo-1615461066841-6116e61058f4?auto=format&fit=crop&w=1200&h=630&q=80" },
  { match: ["thyroid", "fnac", "cytology", "cytopathology"],
    url: "https://images.unsplash.com/photo-1585435557343-3b092031a831?auto=format&fit=crop&w=1200&h=630&q=80" },
  { match: ["oncology", "cancer", "tumour", "tumor", "biopsy", "histopathology", "immunohistochemistry"],
    url: "https://images.unsplash.com/photo-1559757175-5700dde675bc?auto=format&fit=crop&w=1200&h=630&q=80" },
  { match: ["liver", "hepatology", "plasma", "transfusion", "apheresis"],
    url: "https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?auto=format&fit=crop&w=1200&h=630&q=80" },
  { match: ["kidney", "renal", "nephrology"],
    url: "https://images.unsplash.com/photo-1530026405186-ed1f139313f8?auto=format&fit=crop&w=1200&h=630&q=80" },
  { match: ["preventive", "screening", "wellness", "checkup", "check-up", "annual"],
    url: "https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?auto=format&fit=crop&w=1200&h=630&q=80" },
  { match: ["women", "gynaec", "gynec", "cervical", "pap", "endometrium"],
    url: "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?auto=format&fit=crop&w=1200&h=630&q=80" },
  { match: ["microscope", "pathology", "laboratory", "lab"],
    url: "https://images.unsplash.com/photo-1582719471384-894fbb16e074?auto=format&fit=crop&w=1200&h=630&q=80" },
];

const norm = (s) => String(s || "").toLowerCase();

export const coverForArticle = (article) => {
  if (!article) return DEFAULT_ARTICLE_COVER;
  if (article.cover_image && String(article.cover_image).trim()) return article.cover_image;
  const haystack = [
    article.title,
    article.excerpt,
    ...(article.tags || []),
  ]
    .map(norm)
    .join(" ");
  for (const { match, url } of TOPIC_COVERS) {
    if (match.some((k) => haystack.includes(k))) return url;
  }
  return DEFAULT_ARTICLE_COVER;
};

export default coverForArticle;
